// https://github.com/gmpetrov/databerry/blob/main/packages/ui/src/Input.tsx

import FormControl from '@mui/joy/FormControl'
import FormHelperText from '@mui/joy/FormHelperText'
import FormLabel from '@mui/joy/FormLabel'
import Input from '@mui/joy/Input'
import React from 'react'
import Typography from '@mui/joy/Typography'
import InfoOutlined from '@mui/icons-material/InfoOutlined'
import { useController } from 'react-hook-form'

const InputInFormControl = ({ control, name, label, required, helper, ...rest }) => {
  const {
    field,
    fieldState,
  } = useController({
    name: name,
    // rules: rules,
    control: control,
  })

  return (
    <FormControl required={required} error={fieldState.invalid}>
      <FormLabel>{label}</FormLabel>
      <Input variant='outlined' ref={field.ref} value={field.value} disabled={field.disabled} onBlur={field.onBlur} onChange={field.onChange} {...rest} />
      {fieldState.error && <FormHelperText><InfoOutlined />{fieldState.error.message}</FormHelperText>}
      {helper && <Typography level='body-sm'>{helper}</Typography>}
    </FormControl>
  )
}

export default InputInFormControl
